// extracted by mini-css-extract-plugin
export default {"component":"tasks-list_component__pRwdo","loading":"tasks-list_loading__ZTl-S","createBtn":"tasks-list_createBtn__dqI9+","list":"tasks-list_list__Mi0yg"};